import { useReducer, useState } from "react";
import { Item } from "../../utils/sharedTypes";
import UtilitiesFilterBar from "./UtilitiesFilterBar";
import UtilitiesOptionsBar from "./UtilitiesOptionsBar";
import UtilitiesTable from "./UtilitiesTable";
import { UtilitiesFilter } from "./utilitiesTypes";

const initialFilters: UtilitiesFilter = {
  name: undefined,
};

const Utilities = () => {
  const [filters, setFilters] = useReducer(
    (curVals: UtilitiesFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );
  const [selectedUtilities, setSelectedUtilities] = useState<Item[]>([]);
  return (
    <>
      <UtilitiesFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <UtilitiesOptionsBar
        selectedUtilities={selectedUtilities}
        setSelectedUtilities={setSelectedUtilities}
      />
      <UtilitiesTable
        setSelectedUtilities={setSelectedUtilities}
        filters={filters}
      />
    </>
  );
};

export default Utilities;
